export default __webpack_public_path__ + "static/media/tel-aviv.1307c642.svg";